module.exports = __webpack_public_path__ + "93edc0245e727ed784d1997c97d77f09.png";